/**
 * Normalize list-like Redux action payloads (array | Map | plain object values).
 * Shared by market watch and any slice that accepts flexible API shapes.
 */

export function normalizeReduxListPayload(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (payload instanceof Map) return Array.from(payload.values());
  if (typeof payload === "object") return Object.values(payload);
  return [];
}
